import {DOC_VERIFIED} from './DocVerifyType';

export const docVerifyCredential=(props) => {
    return {
        type: DOC_VERIFIED,
        documentsVerified: props.documentsVerified
    }
}